import React, {Component} from 'react';
import {Button, Grid} from '@material-ui/core';

class PlainBtn extends Component {
	
	render() {
		return (
			<Button variant="contained" onClick={this.props.onClick} style={{...this.props.style, height: "3rem", background: this.props.color, color: "white", fontSize: "1rem", lineHeight: "0"}}>
				<Grid container item justify="space-between" alignItems="center">
					<span style={{margin: "0 0.5rem"}}>{this.props.text}</span>
				</Grid>
			</Button>
		);
	}
}

export default PlainBtn;